<template>
	<div class="workflow_component" style="padding: 10px">
        <div class="title">Title</div>
        <div class="multiple">
            <div class="panel">
                <div class="link input_1"></div>
                Fichiers
                <div class="link output_1"></div>
            </div>
        </div>
        <div class="description"></div>
	</div>
</template>

<script>

	export default {
		name: "workflow_component",
		data() {
			return {
                editor: null
			};
		},
        props: {
            title: ""
        },
		methods: {
            async save()
            {

            },
            async load()
            {

            }
		},
		mounted: async function () {
        },
	};
</script>

<style>
    .select
    {
        background: lightgreen;
    }
</style>
